<form [formGroup]="form">
  @if (bannerText) {
    <div class="row mt-4">
      <div class="col-12">
        <div class="mb-3">
          <ds-banner
            [state]="DsBannerState.info"
            [showTitle]="false"
            [showAction]="false"
            [showCloseButton]="true"
            data-test-id="qol-info-banner"
          >
            <div ds-banner-body>
              {{ bannerText }}
            </div>
          </ds-banner>
        </div>
      </div>
    </div>
  }
  <div class="row mt-4">
    <div class="col-12">
      <ds-input
        [label]="'upsert_page_title' | translate"
        [required]="true"
        [errorMessage]="titleError$ | async"
        [errorState]="(titleError$ | async)?.length > 0"
      >
        <input ds-input-field [formControlName]="FormField.TITLE" [maxlength]="titleCharLimit" data-test-id="upsert-page-title" />
      </ds-input>
    </div>
  </div>
  @if (showUrl) {
    <div class="row mt-4">
      <div class="col-12">
        <ds-input
          [label]="'upsert_page_url' | translate"
          [instructions]="'upsert_page_url_instruction' | translate"
          [required]="config?.requireUrl"
          [errorMessage]="urlError$ | async"
          [errorState]="(urlError$ | async)?.length > 0"
          [state]="urlFieldState"
        >
          <input ds-input-field [formControlName]="FormField.URL" data-test-id="upsert-page-url" />
        </ds-input>
        @if (showUrlWarning) {
          <div class="mt-2" data-test-id="upsert-page-duplicate-url-warning">
            <app-edit-permissions-banner [bannerType]="BannerType.info" (onClose)="hideUrlWarning()">
              {{ 'upsert_page_duplicate_url_warning' | translate }}
            </app-edit-permissions-banner>
          </div>
        }
      </div>
    </div>
  }
  <div class="row mt-4">
    <div class="col-12">
      <ds-input
        [label]="'upsert_page_description' | translate"
        [required]="false"
        [errorMessage]="descriptionError$ | async"
        [errorState]="(descriptionError$ | async)?.length > 0"
      >
        <textarea
          ds-input-field
          [formControlName]="FormField.DESCRIPTION"
          [maxlength]="descriptionCharLimit"
          data-test-id="upsert-page-description"
        >
        </textarea>
      </ds-input>
    </div>
  </div>

  @if (screenshotOrigin) {
    <div class="row mt-4">
      <div class="col-auto">
        <label for="upsert-page-remove-screenshot" data-test-id="upsert-page-screenshot-label" class="label text-nowrap">
          {{ 'screenshot' | translate }}
        </label>
      </div>
    </div>
    <div class="row mt-1">
      @switch (screenshotOrigin) {
        @case (ScreenshotOrigin.UPLOADED) {
          <div class="col-12">
            <img
              [appSecureResourceId]="screenshotData.toString()"
              [alt]="'screenshot_preview_alt' | translate"
              class="full-width"
            />
          </div>
        }
        @case (ScreenshotOrigin.NEW) {
          <div class="col-12">
            <img [src]="screenshotData" [alt]="'screenshot_preview_alt' | translate" class="full-width" />
          </div>
        }
      }
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button
          id="upsert-page-remove-screenshot"
          ds-button
          type="button"
          [variant]="DsButtonVariants.microAction"
          [microActionIcon]="Icons.TrashCan"
          [intent]="DsButtonIntent.destructive"
          (click)="removeScreenshot()"
        >
          {{ 'action_remove' | translate }}
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <ds-input
          [label]="'upsert_page_alt_text' | translate"
          [required]="true"
          [errorMessage]="altTextError$ | async"
          [errorState]="(altTextError$ | async)?.length > 0"
        >
          <input
            ds-input-field
            [formControlName]="FormField.ALT_TEXT"
            [maxlength]="altTextCharLimit"
            data-test-id="upsert-page-alt-text"
          />
        </ds-input>
      </div>
    </div>
  } @else {
    <div class="row mt-4">
      <div class="col-12">
        <label for="upsert-page-screenshot" data-test-id="upsert-page-screenshot-label" class="label text-nowrap">
          {{ 'screenshot' | translate }}
        </label>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12">
        <app-file-drag-and-drop
          id="upsert-page-screenshot"
          (fileChange)="onFileUpload($event)"
          [form]="form"
          [formValidationRequest$]="formValidationRequest$"
          [context]="fileUploadContext"
          [showDateAdded]="false"
          ariaLabel="select_or_drag_and_drop_file_to_upload_screenshot"
        ></app-file-drag-and-drop>
      </div>
    </div>
  }
</form>
